import { ApiMutationConfig } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';
import { urlPart } from 'data';
import { IntegrationV1 } from 'features/integration/types';

type PostIntegrationRegistrationLegacyParams = {
  $workspaceId: urlPart;
};

type PostIntegrationRegistrationLegacyRequestBody = IntegrationV1;

type PostIntegrationRegistrationLegacyConfig = ApiMutationConfig<
  PostIntegrationRegistrationLegacyRequestBody,
  PostIntegrationRegistrationLegacyParams,
  void
>;

const url = `${URLS.app}/api/Organizations/$workspaceId/IntegrationSubscription`;

export const postIntegrationRegistrationLegacy =
  createApiEndpoint<PostIntegrationRegistrationLegacyConfig>({
    url,
    method: 'POST',
  });
